import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { BlishAPI } from '@/apis';
import { useStore } from '@/store/useStore';

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found in URL');
          navigate('/login');
          return;
        }

        const response = await BlishAPI.auth.googleSession({
          session_id: sessionId
        });

        useStore.getState().setAuth(response.data.user, response.data.token, response.data.refreshToken);

        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Google auth error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-crown-gold border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white font-semibold">Signing in with Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
